import { IKey } from '../../../shared/types/interfaces/keyboard';

export const Keys: IKey = {
  ArrowDown: 'DOWN',
  ArrowLeft: 'LEFT',
  ArrowRight: 'RIGHT',
  ArrowUp: 'UP',
  Enter: 'SELECT',
  Backspace: 'BACK',
  Escape: 'BACK',
  0: 'ZERO',
  1: 'ONE',
  2: 'TWO',
  3: 'THREE',
  4: 'FOUR',
  5: 'FIVE',
  6: 'SIX',
  7: 'SEVEN',
  8: 'EIGHT',
  9: 'NINE',
  f: 'FASTFORWARD',
  r: 'REWIND',
  i: 'PLAY_PAUSE',
  p: 'PLAY',
  o: 'PAUSE',
  n: 'NEXT',
  b: 'PREVIOUS',
  s: 'STOP',
  '+': 'CHANNEL_UP',
  '-': 'CHANNEL_DOWN',
};
